// extracted by mini-css-extract-plugin
export default {"content":"PostDetailContent_content__s0-CT"};